import { render, staticRenderFns } from "./nuevoClienteModal.vue?vue&type=template&id=5235d412&"
import script from "./nuevoClienteModal.vue?vue&type=script&lang=js&"
export * from "./nuevoClienteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QForm,QInput,QSelect,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QInput,QSelect,QBtn})
